// extracted by mini-css-extract-plugin
export default {"Checkbox":"Styles_Checkbox__IfMxG","icon":"Styles_icon__1b7tn","CheckmarkBox":"Styles_CheckmarkBox__iuxp8"};